module.exports = __webpack_public_path__ + "img/crypto-usdc.a0d924d8.svg";